import Share from './Share';
import QuickShop from './QuickShop';

export default class ProductList {
  constructor({ el }) {
    this.el = el;
    this._onRimgLoad = this._processImage.bind(this);

    this._load();
  }

  reload() {
    this.unload();
    this._load();
  }

  unload() {
    this.el.removeEventListener('rimg:load', this._onRimgLoad);
    this.share.unload();
    this.quickShop.unload();
  }

  _load() {
    this.el.addEventListener('rimg:load', this._onRimgLoad);
    this.share = new Share({ el: this.el });
    this.quickShop = new QuickShop({ el: this.el });
  }

  _processImage() {
    const unprocessedImages = this.el.querySelectorAll('.product-item-image:not(.processed)');

    for (let i = 0; i < unprocessedImages.length; i++) {
      const imageWrapper = unprocessedImages[i];
      const image = imageWrapper.querySelector('img');

      imageWrapper.classList.add('processed');

      if (image && image.getBoundingClientRect().height < 100) {
        const imageOverlay = imageWrapper.querySelector('.product-item-details-overlay');

        imageOverlay.classList.add('landscape');
      }
    }
  }
}
